import React from 'react';

const NewBuildingContactForm = ({
  contactForm,
  handleChange,
  onCancel,
  onSave,
}) => {
  return (
    <div className="p-4 bg-gray-100 rounded-md mt-4 mb-12 border border-gray-200">
      <h3 className="text-lg font-bold mb-4">New Contact</h3>
      <form className="space-y-4">
        {/* Contact Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Contact Name
          </label>
          <input
            type="text"
            name="contactName"
            value={contactForm.contactName}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
            required
          />
        </div>

        {/* Main Phone */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Main Phone
          </label>
          <input
            type="text"
            name="mainPhone"
            value={contactForm.mainPhone}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
          />
        </div>

        {/* Cell Phone */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Cell Phone
          </label>
          <input
            type="text"
            name="cellPhone"
            value={contactForm.cellPhone}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
          />
        </div>

        {/* Email Address */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email Address
          </label>
          <input
            type="email"
            name="emailAddress"
            value={contactForm.emailAddress}
            onChange={handleChange}
            className="w-full border rounded-md p-2"
          />
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-2 mt-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            className="px-4 py-2 border rounded-md bg-blue-500 text-white hover:bg-blue-600"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewBuildingContactForm;
